'use client';

const defaultA11yLabel = "Action Menu";
export {
  defaultA11yLabel
};
